import React, { useState, useEffect } from "react";
import { Section } from "@arp/react-ndbx";
import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getAllQuestions } from "../../../hooks/useAuraService";
import useSharedData from "../../../hooks/useSharedData";
import { getAzureJWTToken } from "../../../utilities/auraHealthUtils";
import CircularProgress from "@mui/material/CircularProgress";
import useTheme from "@mui/material/styles/useTheme";
import ReviewAuraComponentFactory from "../../../factory/ReviewAuraComponentFactory";
import Box from "@mui/material/Box";

function ReviewApplicationUWQuestions({ personOne }) {
  // const azurAccessToken = getAzureJWTToken();
  const { accessToken } = useSharedData();
  const theme = useTheme();
  let sampleCounter = 0;
  const { isLoading, data, isFetching } = useQuery({
    queryKey: ["auraAllQuestion"],
    queryFn: () => getAllQuestions(accessToken),
    // queryFn: () => getAllQuestions(azurAccessToken),
    refetchOnWindowFocus: false,
  });

  const circularProgressStyle = {
    color: `${theme.palette.action.PrimaryAction450}`,
  };

  const StyledLabel = styled((props) => (
    <Section sx={{ textAlign: "left" }} {...props} />
  ))(({}) => ({}));

  const containsParentQuestionId = (nextAuraQuestion) => {
    return nextAuraQuestion?.parentQuestionId ? true : false;
  };

  const getQuestionNumber = (nextAuraQuestion) => {
    if (!containsParentQuestionId(nextAuraQuestion)) {
      sampleCounter = sampleCounter + 1;
    }
    return sampleCounter;
  };

  return (
    <Section md={7}>
      <Section mb={{ xs: 4, md: 6 }}>
        <Typography variant="h3-bold">Your details</Typography>
      </Section>
      {isLoading ? (
        <CircularProgress style={circularProgressStyle} />
      ) : (
        <>
          <StyledLabel>
            <Typography variant="label-large-bold">
              Are you completing this application on your own behalf for your
              individual cover only?
            </Typography>
          </StyledLabel>
          <StyledLabel>
            <Typography variant="p3">Yes</Typography>
          </StyledLabel>
          {!isFetching &&
            data?.responseJson?.map((nextAuraQuestion, index) => (
              <Box key={index}>
                {!containsParentQuestionId(nextAuraQuestion) && (
                  <Section
                    mb={{ xs: 2, md: 3 }}
                    pt={{ xs: 2, md: 3 }}
                    sx={{
                      textAlign: "left",
                      borderTop: `1px solid ${theme.palette.greyscale.Grey550}`,
                    }}
                  >
                    <Typography
                      mb={4}
                      sx={{
                        width: "fit-content !important",
                      }}
                      variant="label-large-bold"
                    >
                      Question {getQuestionNumber(nextAuraQuestion)}
                    </Typography>
                  </Section>
                )}
                <ReviewAuraComponentFactory
                  componentType={nextAuraQuestion.type}
                  nextAuraQuestion={nextAuraQuestion}
                />
              </Box>
            ))}
        </>
      )}
    </Section>
  );
}

export default ReviewApplicationUWQuestions;
